import castArray from 'lodash/castArray';
import isEqual from 'lodash/isEqual';

import {useDocumentContext} from '@/components/document/context';
import Checkbox from '@/components/form/checkbox';
import {DocumentInputField} from '@/engine/types';
import {YesNoChoice} from '@/model/src/values/dv-3';
import {DOMAIN_VALUE_BOOLEAN} from '@/model/types/constants';
import {FieldProps} from '../../meta-field';

export const BooleanField = ({
  field,
  storedValue,
  handleChange,
  handleBlur,
  handleFocus,
}: FieldProps<DocumentInputField>) => {
  const {valueResolver, visibilitySet} = useDocumentContext();

  return (
    <Checkbox
      data-testid={`${field.id}-control`}
      type={field.type}
      label={valueResolver(field.label, {visibilitySet})}
      name={field.id}
      value={YesNoChoice.YES}
      required={field.required}
      checked={isEqual({$ref: `${DOMAIN_VALUE_BOOLEAN}#0`}, castArray(storedValue)[0])}
      onChange={() =>
        handleChange(
          isEqual({$ref: `${DOMAIN_VALUE_BOOLEAN}#0`}, castArray(storedValue)[0])
            ? {$ref: `${DOMAIN_VALUE_BOOLEAN}#1`}
            : {$ref: `${DOMAIN_VALUE_BOOLEAN}#0`},
          true,
        )
      }
      onFocus={handleFocus}
      onBlur={handleBlur}
    />
  );
};
